import { OfferKind } from '@core/offers-types';
import type { Placement } from '@core/placements-types';

import type { PlacementOfferSelectOption } from './offers.types';

export abstract class OfferSelectOptionHelper {
  public static placementsToOfferSelectOptions(
    placements: Placement[],
  ): PlacementOfferSelectOption[] {
    return (
      placements?.map(placement => ({
        ...(placement.offer || placement.talentPool)!,
        id: (placement.offerId ?? placement.talentPoolId)!,
        kind:
          placement.offer?.kind ??
          placement.talentPool?.kind ??
          (placement.offerId != null ? OfferKind.Job : OfferKind.TalentPool),
        stage: placement.stage || null,
      })) ?? []
    );
  }
}
